import React, {useState, useEffect} from "react";
import { Redirect } from 'react-router-dom';
import validator from "validator";
import axios from "axios";
import theme from "../../theme/theme.js";
import Footer from "../../components/Footer/Footer.js";
// Chakra imports
import {
  ChakraProvider,
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/signInImage.png";
import aboutLeftImage from "assets/images/about-left-image.png";

function SignIn(props) {
 
 
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");


 

  return (
    <ChakraProvider theme={theme} resetCss={false} w="100%">
      <Box w="100%">
        <Box w="100%">
          <Box w="100%">
          <Flex position="relative" mb="40px">
              <Flex
                h={{ sm: "initial", md: "75vh", lg: "85vh" }}
                w="100%"
                maxW="1044px"
                mx="auto"
                justifyContent="space-between"
                mb="30px"
                pt={{ sm: "100px", md: "0px" }}
              >
                <Flex
                  alignItems="center"
                  justifyContent="start"
                  style={{ userSelect: "none" }}
                  w={{ base: "100%", md: "50%", lg: "42%" }}
                >
                  <Flex
                    direction="column"
                    w="100%"
                    background="transparent"
                    p="48px"
                    mt={{ md: "150px", lg: "80px" }}
                  >
                    <Heading color={titleColor} fontSize="32px" mb="10px">
                      Page Not Found
                    </Heading>
                    <Text
                      mb="36px"
                      ms="4px"
                      color={textColor}
                      fontWeight="bold"
                      fontSize="14px"
                    >
                      The page you are requesting could not be found
                    </Text>
                 
                    
                  </Flex>
                </Flex>
               
              </Flex>
            </Flex>
          </Box>
        </Box>
        <Box px="24px" mx="auto" width="1044px" maxW="100%">
          <Footer />
        </Box>
      </Box>
    </ChakraProvider>
  );
}

export default SignIn;
